/* IMPORTANT!!!! for other languages change countryCode and api-urls (/src/views) */
import { createI18n } from 'vue-i18n'
import bl from './bl.json'

const i18n = createI18n({
    locale: 'bl',
    fallbackLocale: 'bl',
    globalInjection: true,
    legacy: false,
    messages: {
        bl
    },
    escapeParameterHtml: false,
    messageResolver: null
})

export default i18n